<template>
  <section>
    <b-overlay
      :show="loading"
      rounded
      opacity="0.7"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block w-100"
    >
      <ImportLists
        @reload="reload"
      >

      </ImportLists>
      <section class="header d-flex align-items-center justify-content-between w-100">
        <section class="text-left title">
          <p>Dados importados (Dados planilhados)</p>
        </section>

        <section>
          <button @click="showModalImportLists()" class="btn-send-list-email p-2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10.0026 1.66663V7.08329C10.0026 7.39403 10.1184 7.69362 10.3273 7.92364C10.5362 8.15367 10.8233 8.29763 11.1326 8.32746L11.2526 8.33329H16.6693V16.6666C16.6694 17.0871 16.5106 17.4921 16.2247 17.8004C15.9388 18.1087 15.5469 18.2976 15.1276 18.3291L15.0026 18.3333H5.0026C4.58212 18.3334 4.17713 18.1746 3.86881 17.8887C3.5605 17.6028 3.37164 17.2109 3.3401 16.7916L3.33594 16.6666V3.33329C3.3358 2.91281 3.49461 2.50782 3.78052 2.1995C4.06643 1.89118 4.45831 1.70233 4.8776 1.67079L5.0026 1.66663H10.0026ZM10.0026 9.58329C9.79849 9.58332 9.60149 9.65826 9.44896 9.79389C9.29643 9.92952 9.19899 10.1164 9.1751 10.3191L9.16927 10.4166V11.6666H7.91927C7.70687 11.6669 7.50258 11.7482 7.34813 11.894C7.19368 12.0398 7.10074 12.2391 7.08829 12.4511C7.07585 12.6632 7.14483 12.8719 7.28116 13.0348C7.41748 13.1977 7.61086 13.3024 7.82177 13.3275L7.91927 13.3333H9.16927V14.5833C9.16951 14.7957 9.25084 15 9.39664 15.1544C9.54245 15.3089 9.74173 15.4018 9.95377 15.4143C10.1658 15.4267 10.3746 15.3577 10.5375 15.2214C10.7003 15.0851 10.805 14.8917 10.8301 14.6808L10.8359 14.5833V13.3333H12.0859C12.2983 13.3331 12.5026 13.2517 12.6571 13.1059C12.8115 12.9601 12.9045 12.7608 12.9169 12.5488C12.9294 12.3368 12.8604 12.128 12.7241 11.9651C12.5877 11.8022 12.3944 11.6975 12.1834 11.6725L12.0859 11.6666H10.8359V10.4166C10.8359 10.1956 10.7481 9.98365 10.5919 9.82737C10.4356 9.67109 10.2236 9.58329 10.0026 9.58329ZM11.6693 1.70246C11.9388 1.75967 12.1899 1.88278 12.4001 2.06079L12.5026 2.15496L16.1809 5.83329C16.3762 6.02839 16.5199 6.26892 16.5993 6.53329L16.6326 6.66663H11.6693V1.70246Z"
                    fill="#022245" />
            </svg>
            <span>Enviar lista de e-mails</span>
          </button>
        </section>
      </section>

      <section class="mt-3">
        <table border="1" cellspacing="0" cellpadding="8" style="width:100%; " class="border-none">
          <thead style="background-color:#0b2d4d; color:#fff;">
          <tr class="text-center">
            <th class="py-3 border-none">Arquivo importado</th>
            <th class="py-3 border-none">Baixar arquivo</th>
            <th class="py-3 border-none">Data de vencimento do acesso</th>
            <th class="py-3 border-none">Data da importação</th>
            <th class="py-3 border-none">Log da importação</th>
          </tr>
          </thead>
          <tbody>
          <tr
            class="text-center"
            v-for="importEmailsPlanRelease in importsEmailsPlanRelease"
            :key="importEmailsPlanRelease._id"
            style="border: 1px solid #EDEDED;background: #FFFFFF "
          >
            <td class="py-3 border-none file-name-access-expiration-date">{{ importEmailsPlanRelease.fileName }}</td>
            <td class="py-3 border-none">
              <a
                :href="importEmailsPlanRelease.filePath"
                target="_blank"
                class="file-path-log"
                rel="noopener noreferrer"
              >
                <span v-if="importEmailsPlanRelease.importType === 'link'">Abrir planilha</span>
                <span v-else>Baixar arquivo</span>
              </a>
            </td>
            <td class="py-3 border-none file-name-access-expiration-date">
              {{ formatAccessExpiration(importEmailsPlanRelease) }}
            </td>
            <td class="py-3 border-none file-name-access-expiration-date">
              {{ formatDateComplete(importEmailsPlanRelease.createdAt) }}
            </td>
            <td class="py-3 border-none file-path-log">
              <a
                @click="goToLog(importEmailsPlanRelease._id)"
                class="file-path-log cursor-pointer"
              >
                <span>Visualizar log </span>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </section>

      
      <section>
        <div class='w-100 mb-5 mt-3'>
          <b-pagination
            v-if='importEmailsPlanReleaseMeta.total > 10'
            align="center"
            :per-page='10'
            v-model="importEmailsPlanReleaseMeta.page"
            :total-rows="importEmailsPlanReleaseMeta.total"
            first-text="⏮"
            prev-text="⏪"
            next-text="⏩"
            last-text="⏭"
            @page-click='setPage'
          >
          </b-pagination>
        </div>
      </section>
    </b-overlay>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ImportLists from '@/components/ImportEmailsPlanRelease/ImportLists.vue'
import format from 'date-fns/esm/format/index'


export default {
  name: 'ImportEmailsPlanRelease',
  components: { ImportLists },
  created() {
    const breadcrumb = {
      page: 'Importação de lista de e-mails',
      subPage: {
        name: 'Libere acesso do plano anual com prazo pré-determinado',
        active: false
      },
      tabs: []
    }
    this.setBreadcrumb(breadcrumb)
  },
  data() {
    return {
      loading: false
    }
  },
  async mounted() {
    try {
      this.loading = true
      await this.handlePagedList({})
    } catch (e) {
      this.$bvToast.toast('Ocorreu um erro ao carregar os dados. Tente novamente.', {
        title: 'Atenção',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      })
    } finally {
      this.loading = false
    }
  },
  computed: {
    ...mapGetters('importEmailsPlanRelease', {
      importsEmailsPlanRelease: 'importsEmailsPlanRelease',
      importEmailsPlanReleaseMeta: 'importEmailsPlanReleaseMeta'
    }),
    user() {
      return this.$store.getters['user/current']
    },
    error() {
      return this.$store.getters['access/error']
    }
  },
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('importEmailsPlanRelease', {
      handlePagedList: 'handlePagedList'
    }),
    async reload() {
      await this.handlePagedList({})
    },
    showModalImportLists() {
      this.$bvModal.show('import-lists')
    },
    hideModalImportLists() {
      this.$bvModal.hide('import-lists')
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy')
    },
    formatAccessExpiration(importEmailsPlanRelease) {
      if (importEmailsPlanRelease.expirationType === 'months') {
        const months = importEmailsPlanRelease.expirationMonths
        return `${months} ${months === 1 ? 'mês' : 'meses'} após a importação`
      }
      if (!importEmailsPlanRelease.accessExpirationDate) {
        return '-'
      }
      return this.formatDate(importEmailsPlanRelease.accessExpirationDate)
    },
    formatDateComplete(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },
    async setPage(event, page) {
      this.loading = true
      await this.handlePagedList({ page })
      this.loading = false
    },
    async goToLog(_id) {
      await this.$router.push({ name: 'ImportEmailsPlanReleaseLog', params: {_id} })
    }
  },
  watch: {}
}
</script>

<style lang='scss' scoped>
.header {
  .title {
    font-weight: 700;
    font-size: 18px;
    color: #262626;
  }

  .btn-send-list-email {
    border: 1px solid #AEBBCD;
    border-radius: 5px;
    background: #FFFFFF;
    font-weight: 400;
    font-size: 14px;
    color: #6D7989;
  }
}

.border-none {
  border: none !important;
}

thead {
  font-weight: 600;
  font-size: 14px;
  color: #ECF0F3;
}

.file-name-access-expiration-date {
  font-weight: 400;
  font-size: 15px;
  color: #808080;
}

.file-path-log {
  font-weight: 400;
  font-size: 15px;
  color: #022245;
  text-decoration: underline;
}
</style>
